<template>
	<div class="body">
		<Head2></Head2>
		<div class="pageArea">
			<div class="sortTitle" v-if="thirdCateName!=''">{{$t('pages.category.sort_title_template',{name: thirdCateName})}}</div>
			<div class="sortTitle" v-else-if="secondCateName!=''">{{$t('pages.category.sort_title_template',{name: secondCateName})}}
			</div>
			<div class="sortTitle" v-else>{{$t('pages.category.sort_title_template',{name: firstCateName})}}</div>
			<div class="containerArea">
				<div class="pageLeft">
					<div class="pageLeftLog">
						<img src="../assets/images/logo2.png" />
					</div>
					<div class="treeList">
						<div class="allList">{{$t('pages.category.all_list')}}</div>
						<div>
							<ul>
								<li v-for="(item, index1) in firstList" :key="item.id">
									<div class="title" :class="{active: item.is_show}">
										<router-link :to="{path:'/category',query:{id:item.id}}">
											<div class="title_width_1">{{item.title}}</div>
										</router-link>
										<img src="../assets/images/rightArrowGray.png" class="rightArrowGray"
											v-if="item.is_show" @click="itemClick(item)" />
										<img src="../assets/images/bottomArrowGray.png" class="bottomArrowGray" v-else
											@click="itemClick(item)" />
									</div>
									<ul v-if="item.is_show">
										<li v-for="(subitem,index2) in secondList.filter(p=>p.parent_id==item.id)">
											<div v-if="subitem.title" class="subTitle" @click="itemClick(subitem)">
												<router-link :to="{path:'/category',query:{id:subitem.id}}">
													<div class="title_width_2">{{subitem.title}}</div>
												</router-link>
												<img src="../assets/images/rightArrowGray.png" class="rightArrowGray"
													v-if="subitem.is_show" />
												<img src="../assets/images/bottomArrowGray.png" class="bottomArrowGray"
													v-else />
											</div>
											<ul v-if="subitem.is_show" class="ssubUl" :class="{active: item.is_show}">

												<li
													v-for="(sub2,index3) in thirdList.filter(p=>p.parent_id==subitem.id)">
													<router-link :to="{path:'/category',query:{id:sub2.id}}">
														<div class="title_width_3">{{sub2.title}} </div>
													</router-link>

												</li>

											</ul>
										</li>
									</ul>
								</li>
							</ul>
						</div>


					</div>
				</div>
				<div class="pageRight">
					<div class="rightTitle">
						<div class="titleLine"></div>{{$t('pages.category.all_products_category')}}
					</div>
					<div class="rightSunTitle" v-if="thirdCateName!=''">{{$t('pages.category.path_three', {first: firstCateName, second: secondCateName, third: thirdCateName})}}
					</div>
					<div class="rightSunTitle" v-else-if="secondCateName!=''">{{$t('pages.category.path_two', {first: firstCateName, second: secondCateName})}}
					</div>
					<div class="rightSunTitle" v-else>{{$t('pages.category.path_one', {first: firstCateName})}} </div>
					<div class="rightProLists">
						<div v-for="(item,index) in productList" :key="item.id" class="rightPro">
							<router-link :to="{path:'/detail',query:{id:item.id}}">
								<img :src="item.cover_image" class="proImgRight" />
								<div class="proText">{{item.product_name}}</div>
							</router-link>
						</div>
					</div>
					<div class="paginationArea">
						<PaginationVue :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage">
						</PaginationVue>
					</div>
				</div>

			</div>

		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	import PaginationVue from '../components/pagination.vue';
	export default {
		components: {
			Head2,
			Foot2,
			PaginationVue
		},
		data() {
			return {
				firstList: [],
				secondList: [],
				thirdList: [],
				cateId: 0,
				productList: [],
				number: 1,
				keywords: "",
				firstCateName: "",
				secondCateName: "",
				thirdCateName: "",
				pageIndex:1,
			}
		},
		created() {
			this.cateId = this.$route.query.id;
			this.keywords = this.$route.query.keywords;
			this.getProductList();
			this.getCateList();

		},
		methods: {
			itemClick(item) {
				item.is_show = !item.is_show;
			},
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.getProductList();
			},
			getProductList() {
				this.$scUtil.axiosPut(this, 'ProductApi/GetProductList', {
					cateId: this.cateId,
					keywords: this.keywords,
					pageIndex: this.pageIndex,
					pageSize: 12,

				}, res => {
					if (res.code == 100) {
						this.productList = res.data;
						this.totalcount = res.totalcount;
					}

				});
			},
			getCateList() {
				this.$scUtil.axiosPost(this, 'CategoryApi/GetCategoryTreeList', {
					cateId: this.cateId,

				}, res => {
					if (res.code == 100) {
						res.data.forEach(item => {
							if (item.is_show == '1') {
								if (item.level == 1) {
									this.firstCateName = item.title;
								}
								if (item.level == 2) {
									this.secondCateName = item.title;
								}
								if (item.level == 3) {
									this.thirdCateName = item.title;
								}
								//console.log(2);
								item.is_show = true;
							} else {
								//console.log(3);
								item.is_show = false;
							}
						});
						this.firstList = res.data.filter(p => p.level == 1);
						this.secondList = res.data.filter(p => p.level == 2);
						this.thirdList = res.data.filter(p => p.level == 3);
					}

				});
			}
		}
	}
</script>

<style scoped>
	.body {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #ebecee;
	}

	.pageArea {
		width: 1200px;
	}

	.sortTitle {
		font-size: 13px;
		color: #333333;
		height: 44px;
		line-height: 44px;
	}

	.pageLeft {
		width: 238px;
		margin-right: 20px;
		display: flex;
		flex-direction: column;
	}

	.pageLeftLog {
		width: 236px;
		height: 105px;
		border: 1px solid #e6e6e6;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
	}

	.treeList {
		width: 236px;
		border: 1px solid #e6e6e6;
		background-color: #fff;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
	}

	.allList {
		font-size: 15px;
		height: 37px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #0380fe;
		color: #fff;
	}

	ul li {
		list-style: none;
	}

	.treeList ul li {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		box-sizing: border-box;
	}

	.title,
	.subTitle {
		display: flex;
		justify-content: space-between;
		height: 35px;
		align-items: center;

	}

	.title {
		width: 189px;
		font-size: 14px;
		color: #000000;
		cursor: pointer;
		padding: 0 22px 0 25px;
	}

	.subTitle {
		width: 236px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		padding: 0 22px 0 50px;
		box-sizing: border-box;
	}

	.rightArrowGray {
		width: 5px;
		height: 8px;
	}

	.bottomArrowGray {
		width: 8px;
		height: 5px;
	}

	.ssubUl li {
		font-size: 14px;
		color: #888;
		height: 35px;
		line-height: 35px;
		cursor: pointer;
		padding: 0 22px 0 75px;
		width: 236px;
		box-sizing: border-box;
		display: inline-block;
	}

	.title.active,
	.subTitle:hover,
	.ssubUl li:hover {
		background-color: #e5f2ff;
	}

	.containerArea {
		display: flex;
		margin-bottom: 20px;
	}

	.pageRight {
		flex: 1;
		background-color: #fff;
		padding: 0 28px;
		box-sizing: border-box;
	}

	.rightTitle {
		height: 60px;
		border-bottom: 1px solid #e2e2e2;
		font-size: 14px;
		color: #000000;
		display: flex;
		align-items: center;
	}

	.titleLine {
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 10px;
	}

	.rightSunTitle {
		font-size: 13px;
		color: #333333;
		height: 50px;
		line-height: 50px;
	}

	.rightProLists {
		display: flex;
		flex-wrap: wrap;
	}

	.proImgRight {
		width: 130px;
		height: 130px;
	}

	.proText {
		font-size: 14px;
		color: #666666;
	}

	.rightPro {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 12px;
		margin-bottom: 12px;
	}

	.rightPro:nth-child(6n+6) {
		margin-right: 0;
	}

	.rightLayout {
		margin-bottom: 12px;
	}

	.title_width_1 {
		width: 180px;
	}

	.title_width_2 {
		width: 156px;
	}

	.title_width_3 {
		width: 160px;
	}

	.paginationArea {
		display: flex;
		justify-content: center;
		background-color: #fff;
		padding: 17px 0;
	}
</style>